<template>
  <q-dialog v-bind="$attrs">
    <slot></slot>
  </q-dialog>
</template>
